import { useEffectOnce } from '../../shared/hooks'
import { config } from '../../shared/config'
import LoadingScreen from '../../components/LoadingScreen'

function Login () {
  useEffectOnce(() => {
    window.location.replace(`${config.API_HOST}/auth/login`)
  })

  return <LoadingScreen />
}

export default Login
